<template>
  <el-dialog
    class="sy-address-list"
    :visible.sync="addressListDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="resetQuery"
    @open="handleOpenDialog"
    :title="addressListDialogTitle"
    top="8vh"
    width="840px"
  >
    <div class="search-wrapper">
      <div class="wrapper-inner">
        <el-input :placeholder="pageText.pleaseEnter" type="primary" @keyup.enter.native="searchAddress" v-model="query.addressInfo" size="mini" :validate-event="false"></el-input>
        <el-button type="primary" size="mini" @click="searchAddress">{{pageText.search}}</el-button>
      </div>
    </div>
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane v-if="!hideSystemAddress" :label="pageText.BusinessAddress" lazy name="1">
          <div class="mod-search">
            <el-form ref="form" :model="query" label-width="60px" inline size="mini">
              <el-form-item :label="pageText.administrative" >
                <div class="area">
                  <scity ref="cityArea"
                    v-if="addressListDialog"
                    size="mini"
                    optionalTabs="pcas"
                    placement="bottom-start"
                    partSelectTabs="cas"
                    :partSelect="true"
                    :data="scityRegion"
                    @input="scityInput"
                    @clearAll="clearAll"
                    :disable="areaData && areaData.province && areaData.province.code"></scity>
                </div>
              </el-form-item>
            </el-form>
          </div>
            <div class="sy-address-list-wrapper" v-if="companyData.length">
             <el-form ref="form" :model="form" :rules="rules" class="address-form" size="mini">
                 <el-table
                  size="mini"
                  :data="companyData"
                  max-height="360"
                  style="width: 100%">
                  <el-table-column
                    label=""
                    width="30px">
                    <template slot-scope="scope">
                      <el-radio v-model="currentSelect" :label="scope.$index" @change="changeSelect">&nbsp;</el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="pageText.address"
                  >
                    <template slot-scope="scope">
                      <div class="p-ellipsis" :title="addressStr(scope.row)">
                        {{addressStr(scope.row)}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="pageText.contacts"
                    width="240px"
                  >
                    <template slot-scope="scope">
                      <div v-if="showPerson">
                        <template v-if="editPerson">
                          <div v-if="scope.$index === currentSelect">
                            <el-form-item label="" label-width="0" prop="name">
                              <el-input v-model.trim="form.name" class="input-user-name" size="mini" :placeholder="pageText.PleaseEnterContactPerson"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.name">
                              {{scope.row.name}}
                            </div>
                            <span v-else>--</span>
                          </div>
                        </template>
                        <template v-else>
                          <div v-if="scope.$index === currentSelect && (!scope.row.name || !scope.row.mobile)">
                            <el-form-item label="" label-width="0" prop="name">
                              <el-input v-model.trim="form.name" class="input-user-name" size="mini" :placeholder="pageText.PleaseEnterContactPerson"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.name">
                              {{scope.row.name}}
                            </div>
                            <span v-else>--</span>
                          </div>
                        </template>
                      </div>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="pageText.contactWay"
                    width="240px"
                  >
                    <template slot-scope="scope">
                      <div v-if="showPersonTel">
                          <template v-if="editPersonTel">
                          <div v-if="scope.$index === currentSelect">
                            <el-form-item label=""  prop="mobile">
                              <el-input v-model.trim="form.mobile" class="input-mobile" size="mini" :placeholder="pageText.yourContactInformation"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.mobile">
                              {{scope.row.mobile}}
                            </div>
                            <span v-else>--</span>
                          </div>
                        </template>
                        <template v-else>
                          <div v-if="scope.$index === currentSelect && (!scope.row.name || !scope.row.mobile)">
                            <el-form-item label=""  prop="mobile">
                              <el-input v-model.trim="form.mobile" class="input-mobile" size="mini" :placeholder="pageText.yourContactInformation"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.mobile">
                              {{scope.row.mobile}}
                            </div>
                            <span v-else>--</span>
                          </div>
                        </template>
                      </div>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                </el-table>
            </el-form>
          </div>
          <el-pagination
            class="pagination"
            v-if="pagination.total > 10"
            background
            :current-page.sync="pagination.page"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            :pager-count="5"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next, sizes, jumper"
            :page-sizes="[10, 20, 50, 100]"
          ></el-pagination>
        <div class="no-data-message" v-if="!companyData.length">
          <span>{{pageText.NoAddressavailableatTheMoment}}</span>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button @click="handleDialogCancel">{{pageText.cancel}}</el-button>
      <el-button type="primary" @click="handleSubmit">{{pageText.submit}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import response from '../../../../utils/response'
import Scity from '../../../../../../basis/area/index.vue'

import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)

export default {
  name: 'sy-sy-address-list',
  props: {
    id: {
      type: Number
    },
    addressId: {
      type: Number
    },
    // 行政区域
    areaData: {
      type: Object,
      default: null
    },
    // 收货地址参数
    goodsParam: {
      type: Object
    },
    // 地址选择弹框标题
    addressListDialogTitle: {type: String, default: ''},
    // 是否显示系统地址
    hideSystemAddress: {type: Boolean, default: true},
    // 是否显示联系人
    showPerson: {type: Boolean, default: true},
    // 是否允许编辑联系人
    editPerson: {type: Boolean, default: true},
    // 编辑联系人是否必填
    editPersonRequired: {type: Boolean, default: true},

    // 是否显示联系方式
    showPersonTel: {type: Boolean, default: true},
    // 是否允许编辑联系方式
    editPersonTel: {type: Boolean, default: true},
    // 编辑联系方式是否必填
    editPersonTelRequired: {type: Boolean, default: true},
    addressApi: {type: Object, default: () => ({})}
  },
  data () {
    return {
      addressListDialog: false,
      // 行政区域查询条件 data
      scityRegion: null,
      activeTab: '1',
      form: {
        mobile: '',
        name: ''
      },
      defaultQuery: {
        customCode: null,
        name: null,
        addressInfo: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null
      },
      // 地址查询
      query: {
        stockOrgId: null,
        stockSiteId: null,
        addressInfo: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null
      },
      // 企业地址
      companyData: [],
      // 当前所选地址
      currentSelect: null,
      // 分页
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      rules: {
        name: [
          { required: true, message: pageText.PleaseEnterContactPersons, trigger: 'blur' },
          { pattern: /^.{1,10}$/, message: pageText.nameShouldBeLessThan, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: pageText.phoneNumberOrLandlineNumber, trigger: 'blur' },
          { pattern: /^[0-9-]{3,13}$/, message: pageText.landlineNumberFormatError, trigger: 'blur' }
        ]
      },
      pageText
    }
  },
  methods: {
    // 弹框 取消 按钮回调
    handleDialogCancel () {
      this.addressListDialog = false
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
      this.resetQuery()
    },
    // 关闭弹窗重置查询参数
    resetQuery () {
      this.currentSelect = null
      this.query = Object.assign({}, this.defaultQuery)
      if (!this.areaData) {
        this.scityRegion = null
      }
    },
    handleTabChange () {
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
      this.resetQuery()
      this.pagination.page = 1
      this._getList()
    },
    // 搜索地址
    searchAddress () {
      this.pagination.page = 1
      this._getList()
    },
    changeSelect () {
      if (this.currentSelect || this.currentSelect === 0) {
        this.form.mobile = this.companyData[this.currentSelect].mobile
        this.form.name = this.companyData[this.currentSelect].name
      }
    },
    // 选择地址
    handleSubmit () {
      if (!this.currentSelect &&  this.currentSelect !== 0) {
        return false
      }
      // 企业地址
      if (this.activeTab === '1') {
        // 企业地址有form
        if (this.$refs['form']) {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              const item = JSON.parse(JSON.stringify(this.companyData[this.currentSelect]))
              item.name =  this.form.name || item.name
              item.mobile =  this.form.mobile || item.mobile
              item.goodsName = item.name
              item.goodsPhone = item.mobile
              // 派发修改事件
              this.$emit('addressChange', item)
              this.addressListDialog = false
              // 重置查询
              this.resetQuery()
            }
          })
        }
      }
    },
    // 地址拼接
    addressStr (item) {
      return `${item.provinceName} ${item.cityName} ${item.countyName} ${item.townName || ''} ${item.addressInfo}`
    },
    async handleOpenDialog () {
      this.activeTab = '1'
      this._getList()
    },
    // 切换弹框显示隐藏
    _toggle () {
      this.addressListDialog = !this.addressListDialog
    },
    // 获取地址列表
    async _getList () {
      const api = this.addressApi.companyGoodsAddressList

      const res = await response({
        method: api.type,
        url: api.url,
        params: Object.assign({
          unionSeach: this.query.addressInfo,
          provinceCode: this.query.provinceCode,
          cityCode: this.query.cityCode,
          countyCode: this.query.countyCode,
          townCode: this.query.townCode,
          searchType: 1,
          status: 0,
          isBasic: 1, // 1 基础数据
          type: 0, // 0 公司地址，1 个人地址
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }, this.goodsParam),
        option: {loadingOptions: true}
      })
      if (res.isOk) {
        this.companyData = res.content ? res.content : []
        this.currentSelect = null
        this.computedCurrentSelect()
        this.pagination.total = res.count || 0
      }
    },
    computedCurrentSelect () {
      let data = []
      if (this.activeTab === '1') {
        data = this.companyData
      }
      let index = data.findIndex((item) => {
        return item.id === this.addressId
      })
      if (index >= 0) {
        this.currentSelect = index
      }
      // 企业地址 做选中复制
      if (this.activeTab === '1') {
        this.changeSelect()
      }
    },
    // 查询条件 行政区域 input
    scityInput (data) {
      this.query.provinceCode = (data.province && data.province.code) || ''
      this.query.cityCode = (data.city && data.city.code) || ''
      this.query.countyCode = (data.area && data.area.code) || ''
      this.query.townCode = (data.street && data.street.code) || ''
      this.pagination.page = 1
      this._getList()
    },
    // 查询条件 行政区域 清空
    clearAll () {
      this.query.provinceCode = ''
      this.query.cityCode = ''
      this.query.countyCode = ''
      this.query.townCode = ''
      this._getList()
    },
    // 分页
    handlePageChange (page) {
      this.pagination.page = page
      this._getList()
    },
    handleSizeChange (size) {
      this.pagination.pageSize = size
      this._getList()
    }
  },
  components: {
    Scity
  },
  watch: {
    addressId: {
      handler: function (val) {
        if (val) {
          this.computedCurrentSelect()
        }
      },
      immediate: true
    },
    areaData: {
      handler: function (val) {
        if (val && val.province) {
          this.scityRegion = val
          this.scityInput(val)
          this.defaultQuery.provinceCode = (val.province && val.province.code) || ''
          this.defaultQuery.cityCode = (val.city && val.city.code) || ''
          this.defaultQuery.countyCode = (val.area && val.area.code) || ''
          this.defaultQuery.townCode = (val.street && val.street.code) || ''
        }
      },
      immediate: true
    },
    editPersonRequired: {
      handler (val) {
        this.$set(this.rules.name[0], 'required', val)
      },
      immediate: true
    },
    editPersonTelRequired: {
      handler (val) {
        this.$set(this.rules.mobile[0], 'required', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sy-address-list {
  // 无数据样式
  .no-data-message {
    text-align: center;
    line-height: 50px;
  }

  // 无数据时 新增地址按钮
  .no-data-handler-add {
    display: inline-block;
    color: #3072F3;
    cursor: pointer;
    margin-left: 10px;
  }
  // 公共溢出隐藏
  .p-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  // 列表 表格容器
  .sy-address-list-wrapper {
    margin: 10px 0;
  }
  // 组织列
  .list-column-org-text {
    color: #666;
  }
  // 组织列 更多
  .list-column-org-more {
    display: inline-block;
    margin-left: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .el-radio__label p {
    line-height: 1.5;
    max-width: 326px;
    white-space: normal;
  }
  // 个人地址 操作列 按钮
  .text-btn {
    margin-right: 5px;
  }
  // 个人地址 地址信息列
  .address-p {
    display: inline-block;
    width: 260px;
    white-space: nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  // 个人地址 新增地址按钮
  .personel-add-btn-wrapper {
    float: left;
  }
  // 个人地址 行政区域 样式
  .area-wrapper {
    font-size: 0;
    float: right;
    line-height: 28px;
    .area-title {
      display: inline-block;
      font-size: 12px;
      width: 60px;
      padding-right: 12px;
      color: #707070;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .area {
      display: inline-block;
      width: 190px;
      vertical-align: middle;
    }
  }
  // 默认地址列
  .default-select {
    color: #F80C53;
    border: 1px solid #F80C53;
    border-radius: 2px;
    font-size: 11px;
    display: inline-block;
    width: 24px;
    height: 8px;
    padding: 3px;
    text-align: center;
    line-height: 100%;
    vertical-align: top;
    margin-top: 2px;
  }
  // 搜索区 地址搜索
  .search-wrapper {
    position: relative;
    .wrapper-inner {
      font-size: 12px;
      width: 280px;
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
      z-index: 100;
      .el-input {
        display: inline-block;
        width: 220px;
        margin-right: -4px;
      }
      ::v-deep .el-button--mini {
        border-radius: 0px;
      }
    }
  }
  // 联系人 联系方式 输入框样式
  .input-user-name {
    width: 220px;
    height: 28px;
    ::v-deep .el-input__inner {
      padding: 5px;
    }
  }
  .input-mobile {
    width: 220px;
    height: 28px;
    ::v-deep .el-input__inner {
      padding: 5px;
    }
  }
  .address-form {
    .el-form-item {
      margin-bottom: 13px;
    }
  }
}
</style>
<style lang="scss">
.sy-address-list {
  .el-dialog__body {
    padding: 0 20px 20px;
  }
  .el-select .el-input__inner {
    cursor: default;
    padding-right: 35px;
  }
  .el-input-group__append {
    border-color: #d5d5d5;
  }
  .el-radio__input {
    vertical-align: middle;
    height: 20px;
    .el-radio__inner {
      margin-top: 3px;
    }
  }
  .el-radio__label {
    display: inline-block;
    font-weight: normal;
    vertical-align: middle;
  }
  .el-radio-group {
    display: block;
    margin-top: 15px;
    .radio-item {
      padding: 5px 12px;
      &.is-default {
        &:hover {
        background-color: #F3F8FF;
        .set-default {
          visibility: hidden;
        }
      }
      }
      &:hover {
        background-color: #F3F8FF;
        .set-default {
          visibility: visible;
        }
      }
    }

    .el-radio {
      width: 60%;
      box-sizing: border-box;
      padding-right: 15px;
    }
  }
  .el-form-item__label {
    font-size: 12px;
  }
  .el-form-item__content {
    width: 120px;
  }
  .mod-search {
    .el-form-item__content {
      width: 190px;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #EEE;
  }
}
// 组织名称 -多级组织
.sy-address-list-org-ul {
  max-height: 300px;
  overflow: auto;
  li {
    line-height: 30px;
    color: #333;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  h1 {
    font-size: 12px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    height: 20px;
    line-height: 20px;
  }
  .dots {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin: 0px 10px;
    vertical-align: middle;
  }
}
</style>
